/* istanbul ignore file */
import React from 'react';
import { useAccountUrl } from 'domain/shared/account';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';

const EditAccountButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useAccountUrl();

  return (
    <EditButton path={(id: any) => getUpdateEntityUrl(id)} {...props}>
      Edit
    </EditButton>
  );
};

export default EditAccountButton;
